import React, { ReactElement, useContext, useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Switch, Tooltip } from "@mui/material";
import { BugReport, AspectRatio } from "@mui/icons-material";
import { DebugContext } from "./DebugContext";

export function DebugMenu(): ReactElement | null {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { isBreakpointDebuggerEnabled, setBreakpointDebuggerEnabled } = useContext(DebugContext);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleBreakpointDebuggerToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBreakpointDebuggerEnabled(event.target.checked);
  };

  return (
    <>
      <Tooltip title="Debug menu - Toggle development tools" aria-label="Debug menu">
        <IconButton
          aria-label="debug menu"
          aria-controls="debug-menu"
          aria-haspopup="true"
          onClick={handleMenu}
          color="inherit"
          size="small"
        >
          <BugReport />
        </IconButton>
      </Tooltip>
      <Menu
        id="debug-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleCloseMenu}
      >
        <MenuItem>
          <ListItemIcon>
            <AspectRatio fontSize="small" />
          </ListItemIcon>
          <ListItemText>Breakpoint Debugger</ListItemText>
          <Switch
            checked={isBreakpointDebuggerEnabled}
            onChange={handleBreakpointDebuggerToggle}
            size="small"
            color="secondary"
          />
        </MenuItem>
      </Menu>
    </>
  );
}
